export default "__VITE_ASSET__abd2cf84__"